module.exports = __webpack_public_path__ + "static/media/kulturhistorisk-ansgar-scheffold-TQWshKgaYUg-unsplash.11e17838.jpg";